/**
 * The BlogPosts List container
 */
import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { actions as blogPostActions } from "../../redux/blogposts";
import { push } from "connected-react-router";
// import {setLanguage} from "redux-i18n";
import Page from "../../components/Page";
import BlogPostsListView from "../../components/BlogPostsListView";
import notificationsActions from "../../redux/notifications";
import { Row, Col, Container } from "reactstrap";
import { useSsrEffect } from "@issr/core";

/**
 * Selects props from the store and passes them to the component
 * @param {Object} state the store
 */
const mapStateToProps = (state) => ({
  blogPosts: state.blogPosts.list,
  language: state.i18nState.lang,
});
/**
 * Binds dispatch method to the actions passed as props to the component
 */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      listBlogPosts: blogPostActions.list,
      notify: notificationsActions.showAlert,
      navigateTo: push,
    },
    dispatch
  );

/**
 * The `index` container to show a list of blogPosts
 * Both the component and the connected component are exported for testing purpose.
 * If storing resources is activated, this page will show a list of stored blogPosts when offline
 */
const BlogPosts = (props, context) => {
  const { navigateTo, language, blogPosts, listBlogPosts } = props;

  /** navigates to the show blogPost page if user has permission */
  const handleShowBlogPost = (blogPost_id, event) => {
    navigateTo(`/${language}/blog/${blogPost_id}`);
  };

  /**
   * Frontload function called before component mounts to
   * prefetch the list of blogPosts
   */
  const frontload = async () => {
    listBlogPosts();
  };

  useSsrEffect(frontload, [listBlogPosts, language]);

  return (
    <Page
      id="blogPosts"
      pageType="blog"
      title={context.t("Inspiration, creative ideas and tutorials")}
      description={context.t(
        "In our blog we provide tips and tricks on the subject of adhesive films, stickers and advertising technology."
      )}
      lang={language}
    >
      <Container className="my-5 text-center">
        <h1 className="h3">
          {context.t("Inspiration, creative ideas and tutorials")}
        </h1>
        <p>
          {context.t(
            "In our blog we provide tips and tricks on the subject of adhesive films, stickers and advertising technology."
          )}
        </p>
      </Container>

      <Container>
        <Row>
          {blogPosts.map((post) => (
            <Col xs={12} md={6} lg={3} key={post.id}>
              <BlogPostsListView
                preview={post.content_preview}
                title={post.title}
                slug={post.slug}
                image={post.hero_image}
                onCardClick={handleShowBlogPost}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </Page>
  );
};

/**  define proptype for the 'translation' function  */
BlogPosts.contextTypes = {
  t: PropTypes.func,
};

/** export the redux connected component and add a frontload call */
export default connect(mapStateToProps, mapDispatchToProps)(BlogPosts);
